module.exports = __webpack_public_path__ + "media/images/undraw/shift/schedule_meeting-4af2a46445c74098254a9a99f820855c.png";